<template>
  <div class="app-list-item-image">
    <img v-bind="$attrs" />
  </div>
</template>

<script>
export default {
  name: 'AppListItemImage',
}
</script>

<style lang="scss" scoped>
.app-list-item-image {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 48px;
  width: 20%;
  margin-right: 0.5rem;

  > img {
    max-width: 100%;
  }
}
</style>
